module.exports = __webpack_public_path__ + "static/assets/dc6621dd6adae025d8c707eecede79fd.gif";